<template>
  <!-- oncontextmenu='return false' onselectstart='return false' ondragstart='return false' -->
  <div class="animated fadeIn">
    <!-- <b-card  class="bs-callout bs-callout-primary panelScrollBar"> -->
      <object data="/static/data/데이터RnD팀_광고효과예측솔루션_사용자매뉴얼.pdf#toolbar=0&navpanes=0&scrollbar=0"
      type="application/pdf" width="100%" height="900px" controls controlsList="nodownload"
      oncontextmenu='return false' onselectstart='return false' ondragstart='return false'
      >
      </object>
      <!-- <embed src="/static/data/데이터RnD팀_광고효과예측솔루션_사용자매뉴얼_1116.pdf#toolbar=0&navpanes=0&scrollbar=0" width="100%" height="900"> -->
    <!-- </b-card> -->
  </div>
</template>

<script>
import leftSideUtil from "../common/LeftSideUtil.js"

export default {
  mounted: function() {
    leftSideUtil.highLightMenu('systemInfoCustomId8642');
    // 사이드바 액티브 컨트롤
    ///////////////////////////////
    // document.onmousedown = disableRightclick;
    // var message = "Right click not allowed !!";
    // function disableRightclick(evt){
    //     if(evt.button == 2){
    //         alert(message);
    //         return false;
    //     }
    // }
  },
  methods: {
    handler(e) {
      e.preventDefault();
    },
    test() {
      // alert("오른쪽 버튼은 사용할 수 없습니다.");
      return false;
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/help/SystemInfo.vue